import { fetchV1 } from 'helpers/fetch.js';
import { toQueryString } from 'helpers/api.js';

export default {
  getContentList(filter) {
    return fetchV1.get(`/contents?${toQueryString(filter)}`);
  },
  getContentMetadata(contentId) {
    return fetchV1.get(`/contents/${contentId}`);
  },
  getCompetitorsContent(filters) {
    return fetchV1.get(`/competitor_contents?${toQueryString(filters)}`);
  },
  getSubscribedContent(filters) {
    return fetchV1.get(`/subscribed_contents?${toQueryString(filters)}`);
  },
  getBookmarkedContent(filters) {
    return fetchV1.get(`/bookmarked_contents?${toQueryString(filters)}`);
  },
  getBrandContent(brandId, filters) {
    return fetchV1.get(`/brands/${brandId}/contents?${toQueryString(filters)}`);
  },
  getBrandContentOverTime(brandId, filters) {
    return fetchV1.get(`/brands/${brandId}/contents_over_time?${toQueryString(filters)}`);
  },
  getPublisherContent(publisherId, filters) {
    return fetchV1.get(`/publishers/${publisherId}/contents?${toQueryString(filters)}`);
  },
  getPublisherContentOverTime(publisherId, filters) {
    return fetchV1.get(`/publishers/${publisherId}/contents_over_time?${toQueryString(filters)}`);
  },
  getPartnershipContent(brandId, publisherId, filters) {
    return fetchV1.get(`/brands/${brandId}/publishers/${publisherId}/contents?${toQueryString(filters)}`);
  },
  getHubsContent(brandId, hubId, filters) {
    return fetchV1.get(`/brands/${brandId}/hubs/${hubId}/contents?${toQueryString(filters)}`);
  },
};
